import { FbFormikCheckbox, FbFormikSelect, FbFormikTextField, Slider, Typography } from '@fabricks/ui-components'
import { FieldInputProps, FormikContextType, getIn, useField, useFormikContext } from 'formik'
import React, { ChangeEvent, useEffect, useState } from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { FormElementConfig, FormElementFilterConfig, FormElementProps, FormElementVisibleConfig } from './formGenerator'
import { Hidden, TextField } from '@material-ui/core'

export const isFormElementVisible = (
    field: FieldInputProps<any>,
    form: FormikContextType<unknown>,
    config: FormElementConfig
) => {
    const { visibility } = config
    const isVisible =
        (visibility || [])
            .map((visibleDep: FormElementVisibleConfig) => {
                const targetValue = getIn(form.values, visibleDep.target)
                return visibleDep.isVisible(visibleDep.target, targetValue)
            })
            .filter((element: boolean) => !element).length === 0

    const isDefaultValue = field.value && field.value.length === 0
    if (!isVisible && !isDefaultValue) {
        form.setFieldValue(field.name, '')
    }

    return isVisible
}

export const getFilter = (form: FormikContextType<unknown>, config: FormElementConfig) => {
    const { filter } = config
    return (filter || [])
        .map((formElement: FormElementFilterConfig) => {
            const targetValue = getIn(form.values, formElement.target)
            return formElement.hasFilter(formElement.target, targetValue)
        })
        .filter((element: any) => element)
        .reduce((prev: any, current: any) => {
            Object.keys(current).forEach((key: any) => {
                // eslint-disable-next-line no-param-reassign
                prev[key] = current[key]
            })
            return prev
        }, {})
}

export const FbHiddenTextFieldFormElement = (props: FormElementProps) => {
    const { name, childProps, config } = props
    const form = useFormikContext()
    const [field, meta] = useField(name)

    if (!isFormElementVisible(field, form, config)) {
        return null
    }
    return (
        <TextField
            {...childProps}
        />
    )
}

export const FbTextFieldFormElement = (props: FormElementProps) => {
    const { name, childProps, config } = props
    const form = useFormikContext()
    const [field, meta] = useField(name)

    if (!isFormElementVisible(field, form, config)) {
        return null
    }
    return <FbFormikTextField field={field} form={form} meta={meta} {...childProps} />
}

export const FbCheckboxFormElement = (props: FormElementProps) => {
    const { name, childProps, config } = props
    const form = useFormikContext()
    const [field, meta] = useField(name)

    if (!isFormElementVisible(field, form, config)) {
        return null
    }

    return <FbFormikCheckbox label={childProps.label} field={field} form={form} meta={meta} {...childProps} />
}

export const FbSelectFormElement = (props: FormElementProps) => {
    const { name, childProps, config } = props
    const form = useFormikContext()
    const [field, meta] = useField(name)

    if (!isFormElementVisible(field, form, config)) {
        return null
    }

    return <FbFormikSelect label={childProps.label} field={field} form={form} meta={meta} {...childProps} />
}

export const FbSliderFormElement = (props: FormElementProps) => {
    const { name, childProps, config } = props
    const form = useFormikContext()
    const [field] = useField(name)
    // @ts-ignore
    const [defaultValue] = useState(field.value || form.initialValues[name])

    if (!isFormElementVisible(field, form, config)) {
        return null
    }

    const setValue = (event: ChangeEvent<{}>, value: number | number[]) => {
        const transformedValue = Array.isArray(value) ? value[0] : value
        form.setFieldValue(name, transformedValue, false)
    }

    const customStyles = makeStyles((theme: Theme) =>
        createStyles({
            root: {
                marginBottom: theme.spacing(2),
                color: 'rgba(0, 0, 0, 0.54)',
            },
        })
    )

    const classes = customStyles()

    return (
        <div>
            <Typography variant="caption" align="left" display="block" id="range-slider" className={classes.root}>
                {childProps.label}
            </Typography>
            <Slider
                {...childProps}
                disabled={form.isSubmitting}
                defaultValue={defaultValue}
                onChangeCommitted={setValue}
            />
        </div>
    )
}

export const FbFormikSlider = (props: any) => {
    const { name, label } = props
    const form = useFormikContext()
    const [field] = useField(name)
    // @ts-ignore
    const [defaultValue] = useState(field.value || form.initialValues[name])

    const setValue = (event: ChangeEvent<{}>, value: number | number[]) => {
        const transformedValue = Array.isArray(value) ? value[0] : value
        form.setFieldValue(name, transformedValue, false)
    }

    const customStyles = makeStyles((theme: Theme) =>
        createStyles({
            root: {
                marginBottom: theme.spacing(2),
                color: 'rgba(0, 0, 0, 0.54)',
            },
        })
    )

    const classes = customStyles()

    return (
        <div>
            <Typography variant="caption" align="left" display="block" id="range-slider" className={classes.root}>
                {label}
            </Typography>
            <Slider
                {...props}
                disabled={form.isSubmitting}
                defaultValue={defaultValue}
                onChangeCommitted={setValue}
            />
        </div>
    )
}
